import React from 'react';
import { Col, Row } from 'react-bootstrap';


const Damages = (props) => {

    return (
        <div className="damagesText" >
            <Col >
                <Row className="damagesContent">
                    <Col>
                        <p className="damagesLarge damagesBright">
                            {props.buildings && props.buildings.length > 0 ? props.buildings.length : 0}
                        </p>
                            <p className="damagesLight">Total</p>
                    </Col>
                    <Col>
                        <p className="damagesLarge damagesBright" >
                            {props.criticalBuildings && props.criticalBuildings.length > 0 ? props.criticalBuildings.length : 0}
                        </p>
                        <p className="damagesLight">Critical</p>
                    </Col>
                </Row>
                <small className="damagesLight"># of Structures Impacted at {props.elevation ? props.elevation : 0} ft</small>
            </Col>

        </div>
    );

}

export default Damages;


// WEBPACK FOOTER //
// ./src/components/Damages2/index.js